import { render, staticRenderFns } from "./purInitialReturnList.vue?vue&type=template&id=9a9894e6&scoped=true"
import script from "./purInitialReturnList.vue?vue&type=script&lang=js"
export * from "./purInitialReturnList.vue?vue&type=script&lang=js"
import style0 from "./purInitialReturnList.vue?vue&type=style&index=0&id=9a9894e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9894e6",
  null
  
)

export default component.exports